const ensureCsvExtension = (filename: string) => {
  return filename.toLowerCase().endsWith('.csv') ? filename : `${filename}.csv`;
};

export const createObjectUrlForDownloadItem = (
  file: Blob,
  name: string,
  isCSV = true,
) => {
  const safeName = isCSV ? ensureCsvExtension(name) : name;

  if (file) {
    const url = URL.createObjectURL(file);

    const a = document.createElement('a');
    a.href = url;
    a.download = safeName;

    function handleOnDownload() {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener('click', handleOnDownload);
      }, 150);
    }

    a.addEventListener('click', handleOnDownload, false);
    a.click();
  }
};
